// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"159":"96a7c72a","335":"52e56d95","336":"16e610b9","394":"24b813fd","559":"1a6418ee","692":"5ce20a41","760":"93efe895"}[chunkId] + ".js";
};